import React, { type PropsWithChildren, createContext, useEffect, useState } from 'react';

import type DeviceService from './device.service';

export interface IDeviceContextValues {
  deviceToken?: string;
}

export const DeviceContext = createContext<IDeviceContextValues>({
  deviceToken: undefined,
});

export type IDeviceContextProviderProps = PropsWithChildren<{
  deviceServiceInstance: DeviceService;
}>;

function DeviceContextProvider({ children, deviceServiceInstance }: IDeviceContextProviderProps) {
  const [deviceToken, setDeviceToken] = useState<string | undefined>(undefined);

  useEffect(() => {
    const deviceListener = deviceServiceInstance.addDeviceTokenListener((newToken) => setDeviceToken(newToken));
    setDeviceToken(deviceServiceInstance.getDeviceToken());
    return () => deviceServiceInstance.removeDeviceTokenListener(deviceListener);
    // We do not need to change if the device service instance changes as it's a singleton.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <DeviceContext.Provider value={{ deviceToken }}>{children}</DeviceContext.Provider>;
}

export default DeviceContextProvider;
